import { createContext, FC, useContext, useState } from 'react';

import type { ECommQuoteContextType, Props } from './types';

const eCommQuoteContextDefaultValues: ECommQuoteContextType = {
  featureFlags: undefined,
  setFeatureFlags: () => {
    throw new Error('Function not implemented.');
  },
};

const ECommQuoteContext = createContext<ECommQuoteContextType>(
  eCommQuoteContextDefaultValues
);

export const useECommQuoteContext = () => {
  return useContext(ECommQuoteContext);
};

// testValues prop should only be used to mock out context values in tests
export const ECommQuoteProvider: FC<Props> = ({
  children,
  initialProps,
  testValues,
}) => {
  const [featureFlags, setFeatureFlags] = useState(
    eCommQuoteContextDefaultValues.featureFlags
  );

  return (
    <ECommQuoteContext.Provider
      value={{
        featureFlags,
        setFeatureFlags,
        ...initialProps,
        ...testValues,
      }}
    >
      {children}
    </ECommQuoteContext.Provider>
  );
};
